import { get, post, remove } from "./api";
import routes from "./end-points";

export const tilesApi = {
    initTiles: () => get(routes.admin.tiles.init),
    saveChanges: (dto) => post(routes.admin.tiles.save, dto),
    add: (dto) => post(routes.admin.tiles.add, dto),
    delete: (id) => remove(routes.admin.tiles.delete(id)),
};
